var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperClip = function SvgPaperClip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.506 6.803-5.36 5.36a3.502 3.502 0 0 1-4.953-4.952l5.36-5.36a2.335 2.335 0 0 1 3.302 3.301l-5.366 5.36a1.167 1.167 0 1 1-1.651-1.65L8.79 3.915",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgPaperClip as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M12.506 6.8028L7.14519 12.1636C5.77759 13.5312 3.56028 13.5312 2.19269 12.1636C0.825093 10.796 0.825093 8.57873 2.19269 7.21113L7.55352 1.8503C8.46525 0.938571 9.94346 0.938571 10.8552 1.8503C11.7669 2.76203 11.7669 4.24024 10.8552 5.15197L5.48852 10.5128C5.03266 10.9687 4.29355 10.9687 3.83769 10.5128C3.38182 10.0569 3.38182 9.31783 3.83769 8.86197L8.79019 3.9153' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";